import React from 'react'
import Typography from '@material-ui/core/Typography'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid'


export default class Emerson extends React.Component{
    render(){
	return(
	    <div className="section primary">
		<Grid>
		    <Row>
			<Col xs={12} sm={10} smOffset={1} style={{padding: "0 2rem", textAlign: "center"}}>
			    <h2 className="title">
				we are rich only through what we give
			    </h2>
			    <h2 className="title">
				emerson
			    </h2>
			</Col>
		    </Row>
		</Grid>
	    </div>
	);
    }
}



// WEBPACK FOOTER //
// ./src/components/splash/emerson/index.jsx